import './../scss/main.scss';
import Phaser from 'phaser';
import App from './App';
import { DomReady, getConfigBase } from '@jollywise/jollygoodgame';
import { Load } from './game/scenes/Load';
import { SceneStateMachinePlugin } from './game/components/SceneStatemachinePlugin';
import { SubScenePlugin } from './game/components/SubScenePlugin';
import { GameHudPlugin } from '@jollywise/jollygoodgame/src/components/gamehud/GameHudPlugin';
import { LoaderPluginSesame } from './game/components/GameLoaderSesame';
import { SoundControllerSesame } from './game/components/SoundControllerSesame';
import { ViewportPluginSesame } from './game/components/ViewportPluginSesame';

DomReady(() => {
  const gameConfig = getConfigBase({
    width: 1820,
    height: 780,
    safeWidth: 1820,
    safeHeight: 780,
    components: {
      loader: { component: LoaderPluginSesame, data: { displayScene: Load } },
      subscene: { component: SubScenePlugin },
      stateMachine: { component: SceneStateMachinePlugin },
      soundController: { component: SoundControllerSesame },
      hud: { component: GameHudPlugin },
      viewportController: { component: ViewportPluginSesame },
    },
  });

  const config = { ...gameConfig };
  config.render.antialias = true;
  config.render.antialiasGL = true;
  config.render.batchSize = 4096;
  config.autoRound = true;
  config.roundPixels = true;

  config.type = Phaser.WEBGL; // game is WebGL only

  // Get the meta tag with name="locale"
  var metaTag = document.querySelector('meta[name="locale"]');

  // Get the content attribute value
  config.locale = metaTag.getAttribute('content');
  new App({ config, paths: { base: './', assets: 'assets/' } });
});
